<script>
    import { Breadcrumb, BreadcrumbItem } from '@sveltestrap/sveltestrap';
    import { onMount } from 'svelte';
    import { fetchOneLeagueDraws } from '/public/services/games.js';
    import { Accordion, AccordionItem } from '@sveltestrap/sveltestrap';
    import dayjs from 'dayjs';
    import LockedCourt from '/public/components/draws/LockedCourt.svelte';
    import LeagueStats from '/core/components/stats/LeagueStats.svelte';

    export let params;

    let id = params.leagueID;
    let loading = true;
    let league = null;
    let draws = null;
    let stats = null;

    function loadLeague() {
        fetchOneLeagueDraws(id).then(res => {
            if (res.success) {
                league = res.data.league;
                draws = res.data.draws;
                stats = res.data.stats;

                loading = false;
            }
        });
    }

    onMount(() => {
        loadLeague();
    });

</script>
{#if loading === true}

    <div class='text-center mt-5 mb-5'>
        <h4>
            <span class='ajax-ball-loader'></span> Looking for Draws....
        </h4>
    </div>

{:else}

    <Breadcrumb>
        <BreadcrumbItem>
            <a href="#/">
                Home
            </a>
        </BreadcrumbItem>
        <BreadcrumbItem active>
            League: { league.name }
        </BreadcrumbItem>
    </Breadcrumb>
    
    <div class='clearfix mb-3'>
        <a href='#/' class='btn btn-outline-secondary float-end ms-2'>
            <span class='fas fa-chevron-left'></span> Back to Leagues
        </a>
        <h2>
            <span class='fas fa-volleyball-ball'></span> { league.name }
        </h2>
        <h4>

            <span class='fas fa-calendar text-secondary'></span> { league.day } <span class='fas fa-home text-secondary'></span> { league.venue }

        </h4>
    </div>

    {#if league.email_pre}

        <div class='card mb-3'>
            <div class='card-body'>

                {@html league.email_pre}

            </div>
        </div>

    {/if}

    <hr/>

    {#if league.results}

        <LeagueStats
            stats={stats}
        />

        <hr/>
        
    {/if}

    {#if draws.length == 0}

        <div class='mt-5 mb-5 text-center'>
            <h5 class='text-danger'>
                <span class='fas fa-info-circle'></span> There are no Draws that can be viewed at this time.
            </h5>
        </div>

    {:else}

    <Accordion>

        {#each draws as d,idx}

            <AccordionItem active={idx == 0}>
                <h4 class="m-0" slot="header">
                    
                    <span class='fas fa-volleyball-ball'></span> { dayjs(d.date).format('dddd, DD MMMM YYYY')}

                </h4>

                <p class='text-end'>
                    <a href='/draw-pdf/{ d.id }' class='btn btn-outline-primary' target='_blank'>
                        <span class='fas fa-file-pdf'></span> Download Draw PDF
                    </a>
                </p>

                {#each d.mix as sl}

                    <h1 class='mb-3 text-danger'>

                        <span class='fas fa-clock'></span> { sl.slot }

                    </h1>

                    <div class='row'>

                        {#each sl.courts as c}

                            <div class='col-sm-12 col-md-6 col-lg-4'>
                                <div class='card mb-3 border-info'>
                                    <div class='card-header bg-info text-white text-center'>

                                        <span class='fw-bold'>

                                            { c.court }

                                        </span>

                                    </div>
                                    <div class='card-body'>
                                        
                                        <LockedCourt                                    
                                            match={c}                                                                                
                                        />

                                    </div>
                                </div>
                            </div>

                        {/each}

                    </div>


                    <hr/>

                {/each}
                
            </AccordionItem>

        {/each}

    </Accordion>

    {/if}

    {#if league.email_post}

        <div class='card mb-5 mt-3'>
            <div class='card-body'>

                {@html league.email_post}

            </div>
        </div>

    {/if}

{/if}